import arabicaBeansImg1 from "../assets/images/products/ARABICA.jpg";
import arabicaBeansImg2 from "../assets/images/products/arabica-2.jpg";
import arabicaCoffeeBeansImg1 from "../assets/images/products/Arabica-Coffee-Beans-1.jpg";
import arabicaCoffeeBeansImg2 from "../assets/images/products/Arabica-Coffee-Beans-2.jpg";
import robustaImg1 from "../assets/images/products/Robusta-1.jpg";
import robustaImg2 from "../assets/images/products/Robusta-2.jpg";
import robustaImg3 from "../assets/images/products/robusta-3.jpg";

export const COFFEE_BEANS_PRODUCTS = {
  301: {
    _id: 301,
    id: 301,
    productName: "Arabica Beans",
    price: 499,
    images: [arabicaBeansImg1, arabicaBeansImg2],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    gram: "300 gm",
    productDescription: `<p>Coffee Gable is committed to deliver the most exquisite Arabica coffee beans to your doorstep. Our beans are meticulously sourced from the world's most renowned coffee-producing regions, where the soil, climate, and altitude come together to create coffee beans of unparalleled excellence.</p>
<p>If you are a coffee connoisseur seeking the finest flavors and aromas in your daily brew, you just found Coffee Gable's premium Arabica coffee beans. Grown at higher elevations in regions with ideal climates and conditions, these beans are celebrated for their smooth, mild flavor, and subtle acidity. To ensure the freshness and flavor of every batch, the beans are roasted in small quantities by our experienced roasters. This means you'll experience the true essence of these beans in every cup you brew.</p>
<p>Elevate your coffee experience with our finest Arabica coffee beans. From the break of dawn to those cherished moments of relaxation, our beans will redefine your coffee rituals.</p>`,
  },
  302: {
    _id: 302,
    id: 302,
    productName: "Robusta Beans",
    price: 399,
    images: [robustaImg1, robustaImg2, robustaImg3],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    gram: "300 gm",
    productDescription: `<p>Coffee Gable is committed to deliver the most exquisite coffee beans to your doorstep. Our beans are meticulously sourced from the world's most renowned coffee-producing regions, where the soil, climate, and altitude come together to create coffee beans of unparalleled excellence.</p>
<p>The beans are carefully selected, meticulously roasted, and expertly packaged to ensure you experience the full, unadulterated richness of Robusta in every cup. Whether you prefer your coffee brewed as an intense espresso shot or in a smooth, strong French press, our Robusta coffee beans deliver an exceptional taste that suits various brewing methods.</p>
<p>Elevate your coffee experience to new heights and savor the distinctive flavors of Robusta.</p>`,
  },
  303: {
    _id: 303,
    id: 303,
    productName: "Arabica Coffee Beans",
    price: 399,
    images: [arabicaCoffeeBeansImg2, arabicaCoffeeBeansImg1],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    gram: "300 gm",
    productDescription: `<p>Coffee Gable is committed to deliver the most exquisite Arabica coffee beans to your doorstep. Our beans are meticulously sourced from the world's most renowned coffee-producing regions, where the soil, climate, and altitude come together to create coffee beans of unparalleled excellence.</p>
<p>Our premium green Arabica coffee beans are the perfect solution for those seeking a higher-quality coffee experience while reaping the incredible health benefits. Green coffee beans are bursting with antioxidants that help combat free radicals, promoting overall well-being and a youthful glow. Chlorogenic acid in green coffee beans may aid in weight management by supporting healthy metabolism and reducing the absorption of carbohydrates.</p>
<p>Roasting your green coffee beans at home is a rewarding and enjoyable experience. It allows you to customize your coffee's roast level to suit your taste. Whether you prefer a light, medium, or dark roast, you're in control.</p>
<p>Unlock the true potential of coffee with our green beans. Your daily brew will never be the same!</p>
<p>Remember, each sip is an invitation to a healthier and more flavorful lifestyle. Enjoy the ultimate coffee experience with our premium green coffee beans.</p>`,
  },
};

export function getCoffeeBeansProduct(id) {
  return COFFEE_BEANS_PRODUCTS[id];
}
